import { getValue } from '@Selectors';
import { useSensorTroubleshootState } from '@Selectors/sensorTroubleshoot.selector';
import { SensorTroubleshooting } from '@Types/peek';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

type SensorTroubleshootReturn = {
	sensorTroubleshooting: Partial<SensorTroubleshooting>;
	isOldSensorTroubleshoot: boolean;
	isCurrentlyTesting: boolean;
};

export const useSensorTroubleshoot = (): SensorTroubleshootReturn => {
	const {
		editSensorData: {
			peek: { statusTblt: peekStatus },
		},
	} = useSelector(getValue);

	const sensorTroubleshooting = useSensorTroubleshootState();

	const isOldSensorTroubleshoot = false;

	const isCurrentlyTesting = useMemo(
		() => peekStatus === 'pending',
		[peekStatus],
	);

	return {
		sensorTroubleshooting,
		isOldSensorTroubleshoot,
		isCurrentlyTesting,
	};
};

export default useSensorTroubleshoot;
